import jsPDF from "jspdf";

export type CertSettings = {
  title_en: string; title_hi: string; title_gu: string;
  message_en: string; message_hi: string; message_gu: string;
  signatory_name: string;
  signatory_title_en: string; signatory_title_hi: string; signatory_title_gu: string;
};

export type CertData = {
  name: string;
  certificateNumber: string;
  issuedAt: string;
  visited: number;
  total: number;
  lang: "en" | "hi" | "gu";
  settings: CertSettings;
};

export function downloadCertificatePDF(d: CertData) {
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();

  // Background cream
  doc.setFillColor(252, 245, 230);
  doc.rect(0, 0, W, H, "F");

  // Outer saffron border
  doc.setDrawColor(217, 119, 6);
  doc.setLineWidth(6);
  doc.rect(20, 20, W - 40, H - 40);
  doc.setLineWidth(1);
  doc.rect(34, 34, W - 68, H - 68);

  // Header
  doc.setTextColor(120, 53, 15);
  doc.setFont("times", "bold");
  doc.setFontSize(14);
  doc.text("JAIN GAURAV YATRA", W / 2, 80, { align: "center" });
  doc.setFontSize(10);
  doc.setFont("times", "italic");
  doc.text("Ahmedabad Jain Derasar Pilgrimage", W / 2, 96, { align: "center" });

  // Title
  const title = d.lang === "hi" ? d.settings.title_hi : d.lang === "gu" ? d.settings.title_gu : d.settings.title_en;
  doc.setFont("times", "bold");
  doc.setFontSize(34);
  doc.setTextColor(180, 83, 9);
  doc.text(title, W / 2, 150, { align: "center" });

  // "This is to certify that"
  doc.setTextColor(60, 60, 60);
  doc.setFont("times", "normal");
  doc.setFontSize(13);
  doc.text("This is to certify that", W / 2, 200, { align: "center" });

  // Name
  doc.setFont("times", "bold");
  doc.setFontSize(40);
  doc.setTextColor(146, 64, 14);
  doc.text(d.name, W / 2, 250, { align: "center" });

  // Underline name
  const nameWidth = doc.getTextWidth(d.name);
  doc.setDrawColor(217, 119, 6);
  doc.setLineWidth(1);
  doc.line((W - nameWidth) / 2 - 20, 262, (W + nameWidth) / 2 + 20, 262);

  // Message
  const msg = d.lang === "hi" ? d.settings.message_hi : d.lang === "gu" ? d.settings.message_gu : d.settings.message_en;
  doc.setFont("times", "normal");
  doc.setFontSize(13);
  doc.setTextColor(60, 60, 60);
  const lines = doc.splitTextToSize(msg, W - 200);
  doc.text(lines, W / 2, 300, { align: "center" });

  // Stats
  doc.setFont("times", "bold");
  doc.setFontSize(12);
  doc.setTextColor(146, 64, 14);
  doc.text(`Temples Visited: ${d.visited} / ${d.total}`, W / 2, 360, { align: "center" });

  // Footer left: cert number
  doc.setFont("times", "normal");
  doc.setFontSize(10);
  doc.setTextColor(80, 80, 80);
  doc.text(`Certificate No: ${d.certificateNumber}`, 70, H - 70);
  const _d = new Date(d.issuedAt);
  const _dd = String(_d.getDate()).padStart(2, "0");
  const _mm = String(_d.getMonth() + 1).padStart(2, "0");
  doc.text(`Issued: ${_dd}-${_mm}-${_d.getFullYear()}`, 70, H - 55);

  // Footer right: signatory
  const sigTitle = d.lang === "hi" ? d.settings.signatory_title_hi : d.lang === "gu" ? d.settings.signatory_title_gu : d.settings.signatory_title_en;
  doc.setDrawColor(120, 120, 120);
  doc.line(W - 240, H - 80, W - 70, H - 80);
  doc.setFont("times", "bold");
  doc.setFontSize(11);
  doc.setTextColor(40, 40, 40);
  doc.text(d.settings.signatory_name, W - 155, H - 65, { align: "center" });
  doc.setFont("times", "italic");
  doc.setFontSize(9);
  doc.setTextColor(100, 100, 100);
  doc.text(sigTitle, W - 155, H - 52, { align: "center" });

  // Center seal
  doc.setDrawColor(217, 119, 6);
  doc.setLineWidth(2);
  doc.circle(W / 2, H - 70, 28);
  doc.setFontSize(8);
  doc.setFont("times", "bold");
  doc.setTextColor(146, 64, 14);
  doc.text("JAIN", W / 2, H - 75, { align: "center" });
  doc.text("GAURAV", W / 2, H - 65, { align: "center" });
  doc.text("YATRA", W / 2, H - 55, { align: "center" });

  doc.save(`Certificate_${d.certificateNumber}.pdf`);
}
